export enum ClientSearchFilter {
    FamilyGroup = "Family Group",
    SubRegion = "Sub Region",
    MatterPartner = "Matter Partner",
    MatterManager = "Matter Manager",
}
